module.exports = __webpack_public_path__ + "media/images/icon/icons8-High Priority-e981af440752a611e3fc4821d704f632.png";